import * as actionTypes from "./action-types";

export const setCustomComponentState = (pageState) => {
    
    return {
        type: actionTypes.SET_CUSTOM_COMPONENT_STATE,
        ...pageState
    }
}
